export interface CoproductElement<D extends string, V> {
    discriminator: D;
    value: V;
}

/**
 * @deprecated This type is named incorrectly. Use {@link CoproductElement} instead.
 */
export type CoProduct<D extends string, V> = CoproductElement<D, V>;
